/*
 * Copyright (C) [2025] [Netzint GmbH]
 * All rights reserved.
 *
 * This software is dual-licensed under the terms of:
 *
 * 1. The GNU Affero General Public License (AGPL-3.0-or-later), as published by the Free Software Foundation.
 *    You may use, modify and distribute this software under the terms of the AGPL, provided that you comply with its conditions.
 *
 *    A copy of the license can be found at: https://www.gnu.org/licenses/agpl-3.0.html
 *
 * OR
 *
 * 2. A commercial license agreement with Netzint GmbH. Licensees holding a valid commercial license from Netzint GmbH
 *    may use this software in accordance with the terms contained in such written agreement, without the obligations imposed by the AGPL.
 *
 * If you are uncertain which license applies to your use case, please contact us at info@netzint.de for clarification.
 */

export type SectionCardVariant = 'default' | 'transparent';
export type SectionCardPadding = 'default' | 'compact' | 'none';

export const SECTION_CARD_STYLES = {
  surfaceBase: 'flex flex-col text-card-foreground transition-all duration-300',
  variantBackground: {
    default: 'liquid-glass',
    transparent: '',
  } as Record<SectionCardVariant, string>,
  padding: {
    default: {
      header: 'px-6 py-4',
      body: 'px-6 pb-6',
      bodyWithoutHeader: 'pt-6',
    },
    compact: {
      header: 'px-4 py-3',
      body: 'px-4 pb-4',
      bodyWithoutHeader: 'pt-4',
    },
    none: {
      header: 'p-0',
      body: 'p-0',
      bodyWithoutHeader: '',
    },
  } as Record<SectionCardPadding, { header: string; body: string; bodyWithoutHeader: string }>,
  headerBase: 'flex flex-1 items-center text-base font-semibold leading-none tracking-tight',
  bodyBase: 'text-sm',
} as const;
